<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
    //
  }),
};
</script>

<style scoped>
  .footer{
    background-image: linear-gradient(19deg, #0dbfff 0%, #4000e0 100%);
  }
  
</style>





